export default function FloatingLabels () {
  const INPUT_LABELS = new FloatingLabel('input-wrap float-label', 'input')
  const TEXTAREA_LABELS = new FloatingLabel('textarea-wrap float-label', 'textarea')
}

class FloatingLabel {
  constructor (WRAPPER_ELEMENT, INPUT_TYPE) {
    this.WRAPPER_ELEMENT = WRAPPER_ELEMENT
    this.INPUT_TYPE = INPUT_TYPE
    this.INPUT_SELECTOR = '.' + this.WRAPPER_ELEMENT.split(' ').join('.')
    this.INPUT_WRAPPERS = document.querySelectorAll(this.INPUT_SELECTOR)
    this.init()
  }

  init () {
    if (this.INPUT_WRAPPERS) {
      for (let i = 0; i < this.INPUT_WRAPPERS.length; i++) {
        const INPUT_WRAP = this.INPUT_WRAPPERS[i]
        const INPUT = INPUT_WRAP.querySelector(this.INPUT_TYPE)

        if (INPUT) {
          if (INPUT.value) {
            INPUT_WRAP.classList.add('active')
          }

          if (INPUT.type === 'select-one' || INPUT.type === 'select-multiple') {
            INPUT.addEventListener('change', function () {
              if (this.value) {
                INPUT_WRAP.classList.add('active')
              } else {
                INPUT_WRAP.classList.remove('active')
              }
            })
          } else {
            INPUT.addEventListener('input', function () {
              if (this.value) {
                INPUT_WRAP.classList.add('active')
              } else {
                INPUT_WRAP.classList.remove('active')
              }
            })
          }
        }
      }
    }
  }

  reset () {
    for (let i = 0; i < this.INPUT_WRAPPERS.length; i++) {
      const INPUT_WRAP = this.INPUT_WRAPPERS[i]
      INPUT_WRAP.classList.remove('active')
    }
  }
}